import React, { useState } from 'react'
import { Col, List, Row } from 'antd'
import AppLayout from '../../components/layout/layout'
import Setting from '../../assets/Images/Setting.svg'
import UserCircleGear from '../../assets/Images/UserCircleGear.svg'
import CreditCard from '../../assets/Images/CreditCard.svg'
import Permission from './Permission'
import GeneralSetting from './GeneralSetting'
import Notification from './Notification'
import Payment from './PaymentMethod/Payment'
import Rewards from './Rewards'
import AppInformation from './AppInformation'
import BellSimple from '../../assets/Images/BellSimple.svg'
import Medal from '../../assets/Images/Medal.svg'
import { ListPlus, NotePencil, UsersThree, Clock, Robot } from '@phosphor-icons/react'
import AllListings from './Listings/AllListings'
import AiAssistants from './AiAssistants'
import { useSyncParamsWithRoute } from 'hooks/useUpdateSearchParams'
import { useHistory } from 'react-router-dom'
import dayjs from 'dayjs'
import { BUILD_INFO } from 'config/buildInfo'
const Settings = ({ match }: any) => {
  const history = useHistory()
  const [settingOption, setSettingOption] = useState({
    tab: 'GeneralSetting',
  })
  const { updateRouteParams } = useSyncParamsWithRoute(
    settingOption,
    setSettingOption,
  )

  const data = [
    {
      icon: <img alt="" src={Setting} />,
      title: <b className="b1 setting-optn-tab">General Settings</b>,
      Description: 'General Settings',
      path: 'GeneralSetting',
    },
    {
      icon: <img alt="" src={UserCircleGear} />,
      title: <b className="b1 setting-optn-tab">Permissions</b>,
      Description: 'Manage roles permissions',
      path: 'Permission',
    },
    // {
    //   icon: <Clock size={20} color="#000" />,
    //   title: <b className="b1 setting-optn-tab">Templates</b>,
    //   Description: 'Manage schedule templates',
    //   path: 'Templates',
    // },
    {
      icon: <img alt="" src={BellSimple} />,
      title: <b className="b1 setting-optn-tab">Notifications</b>,
      Description: 'Push notifications settings',
      path: 'Notification',
    },
    {
      icon: <img alt="" src={CreditCard} />,
      title: <b className="b1 setting-optn-tab">Payment method</b>,
      Description: 'Manage roles permissions',
      path: 'Payment',
    },
    {
      icon: <img alt="" src={Medal} />,
      title: <b className="b1 setting-optn-tab">Rewards</b>,
      Description: 'Add kids rewards',
      path: 'Rewards',
    },
    {
      icon: <img alt="" src={CreditCard} />,
      title: <b className="b1 setting-optn-tab">App information </b>,
      Description: 'Manage general app details',
      path: 'AppInformation',
    },
    {
      icon: <Robot size={20} color="#000" />,
      title: <b className="b1 setting-optn-tab">AI Assistants</b>,
      Description: 'Connect ChatGPT or Claude',
      path: 'AiAssistants',
    },
    {
      icon: <ListPlus size={20} color="#000" />,
      title: <b className="b1 setting-optn-tab">Listings</b>,
      Description: 'Manage all listings',
      path: 'listings',
      arrow: true,
    },
    {
      icon: <NotePencil size={20} color="#000" />,
      title: <b className="b1 setting-optn-tab">Web content</b>,
      Description: 'Manage web content',
      path: 'web-content-managment-2',
      arrow: true,
    },
    {
      icon: <UsersThree size={20} color="#000" />,
      title: <b className="b1 setting-optn-tab">Our communities</b>,
      Description: 'Manage communities',
      path: 'manage-communities',
      arrow: true,
    },

  ]

  const SettingHandler = (path: any | null | undefined) => {
    switch (path.tab) {
      case 'GeneralSetting':
        return <GeneralSetting />
      case 'Permission':
        return <Permission />
      case 'Notification':
        return <Notification />
      case 'Payment':
        return <Payment />
      case 'Rewards':
        return <Rewards />
      case 'AppInformation':
        return <AppInformation />
      case 'AiAssistants':
        return <AiAssistants />
      case 'listings':
        return <AllListings />
    }
  }

  const handleItemClick = item => {
    if (item.path === 'web-content-managment-2') {
      history.push('/settings/website-content-managment')
    } else if (item.path === 'manage-communities') {
      history.push('/settings/manage-communities')
    } else {
      updateRouteParams({ tab: item.path })
    }
    // () => updateRouteParams({ tab: item.path })
  }

  return (
    <AppLayout>
      <div className=" page-header main-height setting-main-page">
        <Row gutter={{ sm: 8, md: 16, lg: 24 }} style={{ width: '100%' }}>
          <Col xl={{ span: 16 }} xs={{ span: 14 }}>
            {SettingHandler(settingOption)}
          </Col>
          <Col xl={{ span: 8 }} xs={{ span: 10 }}>
            <List
              className="setting-list"
              itemLayout="horizontal"
              dataSource={data}
              renderItem={item => (
                <List.Item
                  className={
                    item.path === settingOption.tab
                      ? 'setings_active_menu pl-20 pt-20 pb-20 pr-20'
                      : 'cursor_pointer pl-20 pt-20 pb-20 pr-20'
                  }
                  // onClick={() => setSettingOption(item.path)}
                  onClick={() => handleItemClick(item)}
                >
                  <List.Item.Meta
                    avatar={item.icon}
                    title={<b className="b2">{item.title}</b>}
                    description={item.Description}
                  />
                </List.Item>
              )}
            />
            <div
              className="setting-version-footer"
              style={{
                textAlign: 'center',
                padding: '16px 12px 24px',
                color: '#9CA3AF',
                fontSize: 12,
                lineHeight: 1.5,
              }}
              title={`branch: ${BUILD_INFO.branch}`}
            >
              Version {BUILD_INFO.version} · {BUILD_INFO.commit}
              <br />
              Built {dayjs(BUILD_INFO.buildTime).format('MMM D, YYYY · HH:mm')}
            </div>
          </Col>
        </Row>
      </div>
    </AppLayout>
  )
}
export default Settings
